export default "__VITE_ASSET__2417a574__"